import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { COLORS } from "../../utilities/Constants"
import {
	BARRE_FIXE_BAS,
	abonnerNouvelleVersion,
	pageServie,
	recharger,
	rechargementAutoPermis,
	saisieEnCours,
	saisieOuverte,
} from "../../utilities/versionDeploiement"

// Revue 7 (Re1) : clés d'une location du routeur. Une navigation qui porte
// d'autres propriétés (ex. `from: "client-passage"`, `extraData`) les perdrait
// au rechargement → pas de rechargement sur celle-là.
const CLES_LOCATION = ["pathname", "search", "hash", "state", "key"]
const navigationSimple = (location) =>
	Object.keys(location).every((k) => CLES_LOCATION.includes(k))

// Bandeau « Nouvelle version disponible » (rechargement automatique au
// deploy). Revue 6 (D10, Jordan 10.10) : la nouvelle version s'applique au
// prochain CHANGEMENT DE PAGE ou quand l'onglet est MASQUÉ — jamais en pleine
// page, jamais sur une fiche aux modifications non sauvegardées — ou tout de
// suite au clic.
const BandeauNouvelleVersion = () => {
	const history = useHistory()
	const [version, setVersion] = useState(null)
	useEffect(() => abonnerNouvelleVersion(setVersion), [])
	const auto = !!version && rechargementAutoPermis(version)
	useEffect(() => {
		if (!auto) return undefined
		let enCours = false
		// Revue 7 (Re4) : seulement si la page répond (jamais vers un 502).
		const recharge = (encoreLibre) => {
			if (enCours) return
			enCours = true
			pageServie(window.location.pathname).then((ok) => {
				enCours = false
				if (ok && encoreLibre()) recharger(version)
			})
		}
		// history.listen : l'URL est déjà la nouvelle → reload() charge la
		// page demandée avec le nouveau bundle. Revue 7 (Re2) : seulement sur
		// un CHANGEMENT de page (pas un replace de filtres sur la même page).
		let page = history.location.pathname
		const desabonner = history.listen((location) => {
			const changee = location.pathname !== page
			page = location.pathname
			if (!changee || !navigationSimple(location)) return
			if (!saisieEnCours()) recharge(() => !saisieEnCours())
		})
		// Revue 7 (🟠B) : à l'onglet masqué, garde-fous prudents en plus.
		const auMasquage = () => {
			if (document.visibilityState === "hidden" && !saisieOuverte())
				recharge(
					() =>
						document.visibilityState === "hidden" &&
						!saisieOuverte(),
				)
		}
		document.addEventListener("visibilitychange", auMasquage)
		return () => {
			desabonner()
			document.removeEventListener("visibilitychange", auMasquage)
		}
	}, [auto, version, history])
	if (!version) return null
	return (
		<div style={st.bandeau} role="status">
			<span>
				{auto
					? "Nouvelle version disponible — elle s'appliquera au prochain changement de page."
					: "Nouvelle version disponible — rechargez la page pour l'appliquer."}
			</span>
			<button
				type="button"
				style={st.bouton}
				onClick={() => recharger(version)}
			>
				Recharger maintenant
			</button>
		</div>
	)
}
const st = {
	bandeau: {
		position: "fixed",
		left: "50%",
		bottom: `calc(16px + var(${BARRE_FIXE_BAS}, 0px))`,
		transform: "translateX(-50%)",
		zIndex: 4000,
		display: "flex",
		alignItems: "center",
		gap: 12,
		flexWrap: "wrap",
		maxWidth: "calc(100vw - 32px)",
		padding: "10px 14px",
		borderRadius: 10,
		background: COLORS.text,
		color: "#fff",
		fontSize: 13,
		boxShadow: "0 6px 20px rgba(28, 25, 23, 0.25)",
	},
	bouton: {
		border: "none",
		borderRadius: 8,
		padding: "6px 12px",
		background: COLORS.surface,
		color: COLORS.text,
		fontSize: 13,
		fontWeight: 600,
		cursor: "pointer",
		fontFamily: "inherit",
	},
}

export default BandeauNouvelleVersion
